var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_4048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.24498 21.8517H3.1416C2.88271 21.8517 2.67285 21.6419 2.67285 21.383V15.7906C2.67285 15.5317 2.88271 15.3218 3.1416 15.3218H5.24498C5.50387 15.3218 5.71373 15.5317 5.71373 15.7906V21.383C5.71373 21.6419 5.50387 21.8517 5.24498 21.8517Z",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6542 21.8517H13.5508C13.2919 21.8517 13.082 21.6418 13.082 21.3829V17.6509C13.082 17.392 13.2919 17.1822 13.5508 17.1822H15.6542C15.913 17.1822 16.1229 17.392 16.1229 17.6509V21.3829C16.1229 21.6418 15.913 21.8517 15.6542 21.8517Z",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4491 21.8517H8.3457C8.08681 21.8517 7.87695 21.6418 7.87695 21.3829V13.7623C7.87695 13.5034 8.08681 13.2936 8.3457 13.2936H10.4491C10.708 13.2936 10.9178 13.5034 10.9178 13.7623V21.3829C10.9178 21.6418 10.708 21.8517 10.4491 21.8517Z",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8592 21.8517H18.7559C18.497 21.8517 18.2871 21.6419 18.2871 21.383V11.5024C18.2871 11.2436 18.497 11.0337 18.7559 11.0337H20.8592C21.1181 11.0337 21.328 11.2436 21.328 11.5024V21.383C21.328 21.6419 21.1181 21.8517 20.8592 21.8517Z",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.19336 12.6112C4.71113 12.6112 5.13086 12.1915 5.13086 11.6737C5.13086 11.1559 4.71113 10.7362 4.19336 10.7362C3.67559 10.7362 3.25586 11.1559 3.25586 11.6737C3.25586 12.1915 3.67559 12.6112 4.19336 12.6112Z",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39746 8.69641C9.91523 8.69641 10.335 8.27668 10.335 7.75891C10.335 7.24114 9.91523 6.82141 9.39746 6.82141C8.87969 6.82141 8.45996 7.24114 8.45996 7.75891C8.45996 8.27668 8.87969 8.69641 9.39746 8.69641Z",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6025 13.5487C15.1203 13.5487 15.54 13.129 15.54 12.6112C15.54 12.0934 15.1203 11.6737 14.6025 11.6737C14.0848 11.6737 13.665 12.0934 13.665 12.6112C13.665 13.129 14.0848 13.5487 14.6025 13.5487Z",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8066 6.31494C20.3244 6.31494 20.7441 5.89521 20.7441 5.37744C20.7441 4.85967 20.3244 4.43994 19.8066 4.43994C19.2889 4.43994 18.8691 4.85967 18.8691 5.37744C18.8691 5.89521 19.2889 6.31494 19.8066 6.31494Z",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13086 11.6737L8.46058 7.75891",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.335 7.75891L13.6647 12.6112",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.54 12.6112L18.8698 5.37744",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2404 19.5168H16.1699",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83023 19.5168H5.75977",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.62547 19.5168H1.40625C0.888281 19.5168 0.46875 19.0973 0.46875 18.5793V3.08575C0.46875 2.56779 0.888281 2.14825 1.40625 2.14825H22.5938C23.1117 2.14825 23.5312 2.56779 23.5312 3.08575V16.3862",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0348 19.5168H10.9648",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5317 10.6575V18.5793C23.5317 19.0973 23.1122 19.5168 22.5942 19.5168H21.375",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_4048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategy);
export default __webpack_public_path__ + "static/media/strategy.d150b7fc679941c3c6602a9e0dd1121d.svg";
export { ForwardRef as ReactComponent };